<div class="tool-content-container">
  <div class="tool-description">
    Enter a course number and click submit the generate results for prerequisite
    impact.
    <!-- <b class="instructions-title"
      >To generate results for prerequisite impact:</b
    ><br />
    Step 1 <i class="fa-solid fa-arrow-right"></i> Enter a Course Number <br />
    Step 2 <i class="fa-solid fa-arrow-right"></i> Click on the submit button<br />
    Note: -->
    <ul style="list-style: none">
      <li>
        For courses with multiple prerequisite courses you can select the course
        tab to view its graph.
      </li>
      <li>
        When multiple courses has been generated you can click on the row to
        expand.
      </li>
    </ul>

    <b class="warning-note">
      *There will be no additional information for courses with no prerequisite
      courses.
    </b>
  </div>

  <div class="table-parent-div" *ngIf="!!targetCrsTableData.length">
    <table
      multiTemplateDataRows
      mat-table
      [dataSource]="table"
      class="mat-elevation-z8 table-container"
    >
      <!-- Course Code Column -->
      <ng-container matColumnDef="code">
        <th mat-header-cell *matHeaderCellDef>Course Code</th>
        <td mat-cell *matCellDef="let course">{{ course.code }}</td>
      </ng-container>

      <!-- Course Name Column -->
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>Course Name</th>
        <td mat-cell *matCellDef="let course">{{ course.name }}</td>
      </ng-container>

      <!-- College Column -->
      <ng-container matColumnDef="college">
        <th mat-header-cell *matHeaderCellDef>College</th>
        <td mat-cell *matCellDef="let course">{{ course.college }}</td>
      </ng-container>

      <!-- Prerequisite Column -->
      <ng-container matColumnDef="prereqs">
        <th mat-header-cell *matHeaderCellDef>Prerequisites</th>
        <td mat-cell *matCellDef="let course">{{ course.prereqs }}</td>
      </ng-container>

      <!-- Clear Button Column -->
      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef>Action</th>
        <td mat-cell *matCellDef="let course">
          <a mat-icon-button (click)="deleteRow($event, course)">
            <mat-icon aria-hidden="false" aria-label="Delete"
              >delete_forever</mat-icon
            >
          </a>
        </td>
      </ng-container>

      <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
      <ng-container matColumnDef="expandedDetail">
        <td
          mat-cell
          *matCellDef="let element"
          [attr.colspan]="displayedColumns.length"
        >
          <div
            class="example-element-detail"
            [@detailExpand]="
              element == expandedElement ? 'expanded' : 'collapsed'
            "
          >
            <mat-button-toggle-group
              name="prereqs"
              aria-label="Prereq Buttons"
              [(ngModel)]="selected"
            >
              <!-- looping through button toggle for all courses -->
              <ng-container
                *ngFor="
                  let prereq of targetCrsTableData[table.indexOf(element)]
                    .prereqs
                "
              >
                <mat-button-toggle
                  value="{{ prereq.course_code }}"
                  (click)="showChart(element, prereq.course_code)"
                >
                  {{ prereq.course_code }}
                </mat-button-toggle>
              </ng-container>
            </mat-button-toggle-group>
          </div>
          <div *ngIf="element === expandedElement && selectedPrereqCourse">
            <div style="text-align: center; margin-bottom: -20px">
              <button
                matTooltip="Save chart as image"
                mat-icon-button
                aria-label="Chart snap icon"
                (click)="chart.exportChart()"
              >
                <mat-icon>photo_camera</mat-icon>
              </button>
            </div>
            <app-prerequisite-chart
              [displayData]="selectedPrereqCourse"
              [targetCrs]="currentTargetCourse"
              [targetCrsPassRate]="targetCrsPassRate"
            >
            </app-prerequisite-chart>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr
        #tableRow
        mat-row
        *matRowDef="let element; columns: displayedColumns"
        class="example-element-row"
        [class.example-expanded-row]="expandedElement === element"
        (click)="
          expandedElement = expandedElement === element ? null : element;
          showDefaultChart(element)
        "
      ></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: ['expandedDetail']"
        class="example-detail-row"
      ></tr>
    </table>
  </div>

  <back-button></back-button>
</div>
